const styles = {
  imageWrapper: 'overflow-hidden w-full rounded-2',
  title: 'text-body1 mt-4',
  descriptionWrapper: 'flex justify-between mt-1',
  description:
    'text-overline text-gray-3 font-medium line-clamp-3 md:line-clamp-2',
};

export default styles;
